import { useMemo } from "react";

import MetricCard from "../../components/director/module1/MetricCard";
import ModuleShell from "../../components/director/module1/ModuleShell";
import ModuleState from "../../components/director/module1/ModuleState";
import useDirectorSurface from "../../components/director/module1/useDirectorSurface";
import { useDirectorContext } from "@contexts/director";
import { formatCents } from "../../utils/directorFormat";
import { currentCompetence, moduleFilters } from "./module1Utils";

const sum = (items, field) => items.reduce((total, item) => (
  Number.isSafeInteger(item[field]) ? total + item[field] : total
), 0);

const ManagerialDre = () => {
  const { filters } = useDirectorContext();
  const query = useMemo(() => moduleFilters({ from: currentCompetence(), months: 24, filters }), [filters]);
  const surface = useDirectorSurface("managerial-dre", query);
  const items = surface.data?.items || [];
  const limitations = [...new Set(items.flatMap((item) => item.limitations || []))];
  return <ModuleShell
    title="DRE gerencial"
    description="Evidências financeiras disponíveis, sem chamar recebimento de receita contábil."
    badge="Parcial · competência não implantada"
    qualitySources={[surface]}
  >
    <ModuleState {...surface} availability={surface.data?.availability} onRetry={surface.reload} />
    {surface.data && <>
      <section className="director-module1__metrics">
        <MetricCard label="Recebimentos em caixa" value={formatCents(sum(items, "cashReceiptsCents"))} note="Baixas confirmadas" tone="green" />
        <MetricCard label="Saídas de construção" value={formatCents(sum(items, "cashConstructionOutflowCents"))} note="Pagas + comprometidas" tone="orange" />
        <MetricCard label="Resultado líquido" value="Indisponível" note="Reconhecimento e tributos ausentes" />
      </section>
      <section className="director-module1__split">
        <article className="director-module1__panel"><header><div><span className="director-eyebrow">Linhas disponíveis</span><h2>Evidência mensal de caixa</h2></div></header><div className="director-table-scroll"><table className="director-table"><thead><tr><th>Competência</th><th>Recebido</th><th>Previsto</th><th>Construção</th><th>Resultado</th></tr></thead><tbody>{items.map((item) => <tr key={`${item.projectKey}-${item.competence}`}><td>{item.competence}</td><td>{formatCents(item.cashReceiptsCents)}</td><td>{formatCents(item.forecastReceiptsCents)}</td><td>{formatCents(item.cashConstructionOutflowCents)}</td><td>Indisponível</td></tr>)}</tbody></table></div></article>
        <aside className="director-module1__insight"><span className="director-eyebrow">Por que é parcial</span><h2>Caixa não é receita reconhecida</h2><p>Sem competência de vendas, CPV/POC, impostos e comissões, margens e resultado líquido permanecerão bloqueados.</p><ul className="director-module1__limitations">{limitations.map((item) => <li key={item}>{item.replaceAll("_", " ")}</li>)}</ul></aside>
      </section>
    </>}
  </ModuleShell>;
};

export default ManagerialDre;
